<template>
  <Content @back="back">
    <template v-slot:nav_left>
      <!-- 运动能力测试 -->
      <div class="nav_wrap">
        <div class="nav_list">
          <div v-for="(item, index) in navList" :key="index">
            <span
              class="nav_item"
              :class="item.idx === idx ? 'active' : ''"
              @click="changeNav(item.idx)"
              >{{ item.name }}</span
            >
            <!-- <span class="nav_item active">{{ item }}</span> -->
          </div>
        </div>
      </div>
    </template>
    <template v-slot:nav_right>
    <div v-if="idx===1" class="yioks_btn"  @click="handleSubmitDoc" >
    批量上传球员运动能力测试
    </div>
    </template>
    <template v-slot:content_right>
      <div style="width: 100%; height: 100%">
        <template v-if="1 === idx">
          <body-list ref="bodyList" key="body" />
        </template>
        
        <template v-if="0 === idx">
          <guanfang-list ref="bodyList" key="guanfang" />
        </template>
  
        <template v-if="2 === idx">
          <resuly-list-guanfang></resuly-list-guanfang>
        </template>

        <template v-if="3 === idx">
          <resuly-list></resuly-list>
        </template>
      </div>
    </template>
  </Content>
</template>

<script>
import storage from '@/utils/storage'
export default {
  data() {
    const adminNav = [
      // { name: '官方测试', idx: 0 },
      { name: '运动能力测试', idx: 1 },
      // { name: '官方测试分析排名', idx: 2 },
      { name: '运动能力分析排名', idx: 3 },
    ]
    const otherNav = [
      { name: '官方测试', idx: 0 },
      { name: '自行测试', idx: 1 },
    ]
    return {
      idx: 1,
      // navList: storage.get('userInfo').userRole === 'system' || storage.get('userInfo').userRole === 'admin' ? ["官方测试","自行测试", "官方测试分析排名","自行测试分析排名"] : ["官方测试","自行测试"],
      navList: storage.get('userInfo').userRole === 'system' || storage.get('userInfo').userRole === 'admin' ? adminNav : otherNav,
      // navList:['运动能力测试']
    };
  },

  components: {
    Content: () => import("@/components/layout/list"),
    "body-list": () => import("./components/BodyList"),
    "resuly-list": () => import("./components/ResultList"), // 自行测试排名（运动能力测试排名）
    "resuly-list-guanfang": () => import("./components/ResultListGuanfang"),  // 官港测试排名
    "guanfang-list": () => import("./components/BodyList"),
  },

  created() {
    this.changeQuery(true);
  },

  methods: {
    back(){
      if ( storage.get('userInfo').userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    handleSubmitDoc() {
      this.$refs.bodyList.openDialog();
    },
    changeNav(index) {
      if (index === this.idx) return;
      this.idx = index;
      this.changeQuery(false);
    },
    changeQuery(flag) {
      if(flag) {
        const { idx } = this.$route.query;
        this.idx = +idx || 1; // 默认使用 idx=1； 运动能力测试
        const fullpath = this.$route.fullpath;
        this.$router.replace({
          path: fullpath,
          query: {
            ...this.$route.query,
            idx: this.idx,
          }
        })
      }else {
        const fullpath = this.$route.fullpath;
        this.$router.replace({
          path: fullpath,
          query: {
            idx: this.idx,
          }
        })
      }
      
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable';

.nav_wrap {
  display: flex;
  justify-content: space-between;
  font-size: 16px;

  .nav_list {
    display: flex;

    .nav_item {
      cursor: pointer;
      user-select: none;
      padding: 10px 15px;

      &.active {
        background: $green_color;
      }
    }
  }
}
</style>
